/* eslint-disable */

import React, { useState } from 'react'
import { Button } from '../../Components/ui/button'
import { Card, CardContent } from '../../Components/ui/card'
import { Input } from '../../Components/ui/input'
import { Label } from '../../Components/ui/label'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { toast } from 'sonner'

const RefreshData = () => {
  const [days, setDays] = useState('30')
  const [loading, setLoading] = useState({
    allotment: false,
    redemption: false,
    order: false,
  })

  const refreshAllotment = async () => {
    setLoading((prev) => ({ ...prev, allotment: true }))
    try {
      const response = await post(
        `${env.API_URL}mutualfundservice/api/mutualFund/newAllotmentStatement/dataRefresh`,
        { days },
      )

      if (response?.isError) {
        toast.error('Failed to refresh allotment data')
      }

      if (!response?.isError && response?.status === 'SUCCESS') {
        toast.success(response?.message)
      }
    } catch (error) {
      alert('Failed to refresh allotment data')
    } finally {
      setLoading((prev) => ({ ...prev, allotment: false }))
    }
  }

  const refreshRedemption = async () => {
    setLoading((prev) => ({ ...prev, redemption: true }))
    try {
      const response = await post(
        `${env.API_URL}mutualfundservice/api/mutualFund/redemptionStatus/dataRefresh`,
        {
          days,
        },
      )

      if (response?.isError) {
        toast.error('Failed to refresh redemption data')
      }

      if (!response?.isError && response?.status === 'SUCCESS') {
        toast.success(response?.message)
      }
    } catch (error) {
      toast.error('Failed to refresh redemption data')
    } finally {
      setLoading((prev) => ({ ...prev, redemption: false }))
    }
  }

  const refreshOrder = async () => {
    setLoading((prev) => ({ ...prev, order: true }))
    try {
      const response = await post(
        `${env.API_URL}mutualfundservice/api/mutualFund/orderStatus/dataRefresh`,
        {
          days,
        },
      )

      if (response?.isError) {
        toast.error('Failed to refresh order data')
      }

      if (!response?.isError && response?.status === 'SUCCESS') {
        toast.success(response?.message)
      }
    } catch (error) {
      alert('Failed to refresh order data')
    } finally {
      setLoading((prev) => ({ ...prev, order: false }))
    }
  }

  return (
    <div className='max-w-xl mx-auto mt-10 p-6'>
      <Card className='shadow-xl rounded-2xl'>
        <CardContent className='space-y-6 py-6'>
          <div className='space-y-2'>
            <Label htmlFor='days'>Number of Days</Label>
            <Input
              id='days'
              type='number'
              value={days}
              onChange={(e) => setDays(e.target.value)}
              min={1}
              max={365}
              className='w-full'
            />
          </div>

          <div className='grid gap-4'>
            <Button onClick={refreshAllotment} disabled={loading.allotment} className='w-full'>
              {loading.allotment ? 'Refreshing Allotment...' : 'Refresh Allotment'}
            </Button>

            <Button onClick={refreshRedemption} disabled={loading.redemption} className='w-full'>
              {loading.redemption ? 'Refreshing Redemption...' : 'Refresh Redemption'}
            </Button>

            <Button onClick={refreshOrder} disabled={loading.order} className='w-full'>
              {loading.order ? 'Refreshing Orders...' : 'Refresh Orders'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default RefreshData
